import {
  type CustomCell,
  type CustomRenderer,
  GridCellKind,
  getMiddleCenterBias,
} from '@glideapps/glide-data-grid'

interface SpinnerCellProps {
  readonly kind: 'spinner-cell'
  readonly copy: string
}

export type SpinnerCell = CustomCell<SpinnerCellProps>

export const SpinnerCellRenderer: CustomRenderer<SpinnerCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is SpinnerCell =>
    (cell.data as any).kind === 'spinner-cell',
  needsHover: false,
  needsHoverPosition: false,
  draw: (args) => {
    const { ctx, theme, rect, requestAnimationFrame } = args

    const spinnerRadius = Math.min(12, rect.height / 6)

    if (args.cell.data.copy) {
      const xPad = theme.cellHorizontalPadding
      const drawX = rect.x + xPad + spinnerRadius * 4

      ctx.font = theme.baseFontFull
      ctx.fillStyle = theme.textDark
      ctx.fillText(
        args.cell.data.copy,
        drawX,
        rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme)
      )
    }

    const progress = (window.performance.now() % 1000) / 1000
    const xPad = theme.cellHorizontalPadding

    const x = rect.x + xPad * 2
    const y = rect.y + rect.height / 2
    ctx.beginPath()
    ctx.arc(
      x,
      y,
      spinnerRadius,
      Math.PI * 2 * progress,
      Math.PI * 2 * progress + Math.PI * 1.5
    )

    ctx.strokeStyle = theme.accentColor
    ctx.lineWidth = 1.5
    ctx.stroke()

    ctx.lineWidth = 1

    requestAnimationFrame()

    return true
  },
  provideEditor: () => undefined,
}
